import { createSelector } from 'reselect';

const selectEmployeeList = (state: any) => state.employeelist;

export const selectEmployeeListData = createSelector(
	[selectEmployeeList],
	(state: any) => state.employeelistData,
);

export const selectEmployeeNameAndID = createSelector(
	[selectEmployeeList],
	(state: any) => state.employeelistData,
);

export const selectAllEmployeeListData = createSelector(
	[selectEmployeeList],
	(state: any) => state.allEmployeeListData,
);

export const selectEmployeeDetailsBasedOnIDResponce = createSelector(
	[selectEmployeeList],
	(state: any) => state.employeeDetailsBasedOnIDResponce,
);

export const selectEmployeeByIDResponseArray = createSelector(
	[selectEmployeeList],
	(state: any) => state.employeeDetailsBasedOnIDArray,
);

export const selectUpdateEmployeeByIDResponse = createSelector(
	[selectEmployeeList],
	(state: any) => state.updateEmployeeResponse,
);

export const selectUpdateEmployeeResponse = createSelector(
	[selectEmployeeList],
	(state: any) => state.updateEmployee,
);
